var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ loading: _vm.loading },attrs:{"id":"map"}},[_c('layers-loader',{attrs:{"items":_vm.layersLoader}}),_c('map-zoom-level',{staticStyle:{"left":"9px"},attrs:{"zoom-level":_vm.mapZoom}}),(_vm.loading)?_c('v-progress-circular',{staticClass:"map__loader",attrs:{"color":"primary","width":7,"indeterminate":"","size":"64"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }